import React from 'react';
import { InvoiceTemplateProps } from './types';
import PatientInfo from './primitives/PatientInfo';
import ItemsTable from './primitives/ItemsTable';
import Totals from './primitives/Totals';
import Footer from './primitives/Footer';

export default function Template6_HeaderImageUpload({ invoice, hospital }: InvoiceTemplateProps) {
  return (
    <div className="bg-white p-8 max-w-[210mm] mx-auto" style={{ minHeight: '297mm' }}>
      {/* Custom Header Image */}
      {hospital.headerImage ? (
        <div className="mb-6">
          <img 
            src={hospital.headerImage} 
            alt="Header" 
            className="w-full h-auto max-h-32 object-contain"
            crossOrigin="anonymous"
          />
        </div>
      ) : (
        <div className="mb-6 border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
          <p className="text-gray-500">Custom Header Image Area</p>
          <p className="text-sm text-gray-400 mt-2">Upload your custom header image in settings</p>
        </div>
      )}
      
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900 uppercase">Invoice</h2>
      </div>

      <PatientInfo invoice={invoice} layout="grid" />
      
      <ItemsTable items={invoice.items} variant="standard" headerColor="bg-primary-600" />
      
      <Totals invoice={invoice} layout="standard" showPaymentInfo={true} />
      
      <Footer variant="signature" notes={invoice.notes} />
    </div>
  );
}
